var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5186 28.7104L31.7186 26.9004V22.4404V22.4404C31.7681 19.0157 29.2841 16.0793 25.8986 15.5604V15.5604C22.2081 15.0744 18.8223 17.6722 18.3363 21.3627C18.2984 21.6504 18.2791 21.9402 18.2786 22.2304V26.9004L16.4786 28.7104H16.4786C15.8435 29.3561 15.8521 30.3945 16.4978 31.0296C16.8023 31.3291 17.2116 31.498 17.6386 31.5004H20.9986V31.8404V31.8404C21.0959 33.9541 22.8846 35.5908 24.9986 35.5004C27.1126 35.5908 28.9014 33.9541 28.9986 31.8404V31.5004H32.3586C33.2644 31.4953 33.9945 30.757 33.9894 29.8512C33.987 29.4242 33.8181 29.0149 33.5186 28.7104V28.7104ZM27 31.8405C26.8848 32.8398 26.0034 33.5713 25 33.5005C23.9966 33.5713 23.1152 32.8398 23 31.8405V31.5005H27V31.8405ZM18.5086 29.5004L19.6886 28.3204C20.0667 27.9446 20.279 27.4335 20.2786 26.9004V22.2304V22.2306C20.2797 20.8658 20.8702 19.5679 21.8985 18.6705L21.8985 18.6705C22.9133 17.751 24.2807 17.3232 25.6386 17.5004C28.0298 17.8887 29.7699 19.9785 29.7186 22.4004V26.9004V26.9004C29.7156 27.432 29.9243 27.943 30.2986 28.3204L31.4886 29.5004L18.5086 29.5004Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3848 23.1667C32.7919 23.1667 34.7696 21.241 34.7696 18.8333C34.7696 16.4257 32.7919 14.5 30.3848 14.5C27.9776 14.5 26 16.4257 26 18.8333C26 21.241 27.9776 23.1667 30.3848 23.1667Z",
    fill: "#E80000",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.9850806cb81722891078845391ced5ee.svg";
export { ForwardRef as ReactComponent };